import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  ObrazacUnosaDTO,
  ObrazacUnosaService
} from '@app/components/fast-data-entry/service/obrazac-unosa.service';
import { AppUser, AuthService, EMPTY } from '@app/components/login.component';
import {
  Action,
  ActionRequiresRefresh,
  Item,
  ItemViewProviderDirective,
  NtapGlobalConstants,
  UIComponents,
  Util,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-fast-data-entry-edit-template-bar',
  templateUrl: './fast-data-entry-edit-template-bar.component.html',
  styleUrls: ['./fast-data-entry-edit-template-bar.component.scss'],
  providers: [WindowRegistry]
})
export class FastDataEntryEditTemplateBarComponent implements OnInit {
  private authService = inject(AuthService);
  private entryTemplateService = inject(ObrazacUnosaService);
  private itemViewProviderDirective = inject(ItemViewProviderDirective);

  @ViewChild(ViewWindowComponent)
  editTemplateWindow: ViewWindowComponent;

  private editEntryTemplateActionParams: Action = {
    name: 'openObrazacOpisaGradiva',
    tooltip: 'Uredi obrazac unosa',
    ui_component: UIComponents.ACTION_OPEN_ITEMVIEW,
    $openItemType: 'earhiv~obrazac_opisa_gradiva',
    $openViewName: 'obrazac_opisa_item',
    disabled: false,
    requires_refresh: ActionRequiresRefresh.LIST_ITEM,
    open_ui_compid: UIComponents.ITEMVIEW,
    close_view: false,
    requires_attributes: false,
    target: 'detail',
    depends_on_attribute: '',
    icon: 'pi pi-file-edit',
    description: ''
  };

  newEntryTemplateActionParams: Action = Object.assign(
    {},
    this.editEntryTemplateActionParams,
    {
      tooltip: 'Novi obrazac unosa',
      icon: 'file-word'
    }
  ) as Action;

  private deleteEntryTemplateActionParams: Action = {
    name: 'deleteObrazacOpisaGradiva',
    tooltip: 'Obriši obrazac unosa',
    ui_component: UIComponents.ACTION_SERVER,
    $openItemType: '',
    $openViewName: '',
    disabled: false,
    requires_refresh: ActionRequiresRefresh.ITEM,
    close_view: false,
    requires_attributes: false,
    depends_on_attribute: '',
    target: 'detail',
    open_ui_compid: '',
    icon: 'pi pi-file-excel',
    description: ''
  };

  entryTemplateItem$: Observable<Item>;

  editEntryTemplateActionParams$: Observable<Action>;

  deleteEntryTemplateActionParams$: Observable<Action>;

  ngOnInit() {
    this.editEntryTemplateActionParams$ = this.getActionObservable(
      this.editEntryTemplateActionParams
    );
    this.deleteEntryTemplateActionParams$ = this.getActionObservable(
      this.deleteEntryTemplateActionParams
    );
    this.entryTemplateItem$ =
      this.entryTemplateService.selectEntryTemplate$.pipe(
        switchMap((selectedEntryTemplate) => {
          return this.itemViewProviderDirective.view$.pipe(
            map(() => {
              return {
                [Util.getFullAttrName('earhiv~obrazac_opisa_gradiva', 'id')]:
                  selectedEntryTemplate.id,
                [NtapGlobalConstants.ATTR_$itemType]:
                  'earhiv~obrazac_opisa_gradiva'
              };
            })
          );
        })
      );
  }

  private getActionObservable(actionParams: Action): Observable<Action> {
    return this.entryTemplateService.selectEntryTemplate$.pipe(
      switchMap((entryTemplate) => {
        return this.authService.user$.pipe(
          map((user) => {
            const action = Object.assign({}, actionParams, {
              disabled: this.calculateActionDisabled(entryTemplate, user)
            });
            return action;
          })
        );
      })
    );
  }

  private calculateActionDisabled(
    item: ObrazacUnosaDTO,
    user: AppUser | EMPTY
  ) {
    let disabled = false;
    if (item.name === 'entry_template_sazeti_opis_item') {
      disabled = true;
    } else if (item.grupaObrasca === 'Institucionalni') {
      disabled = !AuthService.userHasAnyRole(user, [
        'Glavni administrator',
        'Administrator arhiva'
      ]);
    } else if (item.grupaObrasca === 'Sustav') {
      disabled = !this.authService.userHasRole(user, 'Glavni administrator');
    }
    return disabled;
  }
}
